import api from '../api'
export default {

  getAddress (page = 0, word = '', size = 5) {
    return api.request('GET', '/address/list?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
  },
  create(form) {
    return api.request('POST', '/address/create', form);
  },
  delete(id) {
    return api.request('DELETE', '/address/delete/' + id);
  },
  getByID(id){
    return api.request('GET', '/address/' + id);
  },
  update(id, form){
    return api.request('PUT', '/address/update/' + id, form);
  }

}
